import { useEffect } from 'react';

export const useFavicon = (url: string | null | undefined): void => {
  useEffect(() => {
    if (!url) return;
    let link = document.querySelector(
      "link[rel='icon']"
    ) as HTMLLinkElement | null;
    const created = !link;
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    const iconLink = link;
    const previousHref = iconLink.href;
    iconLink.href = url;
    return () => {
      if (created) {
        iconLink.parentNode?.removeChild(iconLink);
      } else {
        iconLink.href = previousHref;
      }
    };
  }, [url]);
};
